import { Trans } from '@lingui/macro';
import { observer } from 'mobx-react-lite';
import React, { FC, useState, useEffect, useContext } from 'react'
import Modal from 'react-modal';
import { Accordion, Toast } from 'react-bootstrap';
import { Context } from '../../..';
import { useNavigate } from 'react-router-dom';
import { formats, modules } from './QuillSettings';
import ReactQuill from 'react-quill';
import DocumentsService from '../../../services/DocumentsService';
import { ModalPopover } from './modal-popover';
import { MyDocsModal } from './MyDocsModal';
import { RecsNosologyModal } from './RecsNosologyModal';

const Recommendation: FC<any> = observer(({ rec, i, setDelModal, setDelId }) => {


    return (
        <Accordion.Item eventKey={i}>
            <Accordion.Header>
                {rec['name'] + (rec['type'] === 1 ? ' (родителям)' : ' (специалистам)')}
                <i className='icon trash ms-3' onClick={() => {
                    setDelId(rec['id']);
                    setDelModal(true);
                }} />
            </Accordion.Header>
            <Accordion.Body>
                <ReactQuill
                    value={rec['recommendation']}
                    className='react-quill'
                    readOnly={true}
                    theme="bubble"
                />
            </Accordion.Body>
        </Accordion.Item>
    )
});

interface ModalProps {
    toggle: boolean;
    setToggle: (value: boolean) => void;
}

export const RecommendationsOfSpecsModal: FC<ModalProps> = props => {
    const { toggle, setToggle } = props;
    const { store } = useContext(Context);
    const navigate = useNavigate();
    const [name, setName] = useState('');
    const [text, setText] = useState('');
    const [type, setType] = useState('1');
    const [nosology, setNosology] = useState<any>([]);
    const [recommendations, setRecommendations] = useState([]);
    const [delId, setDelId] = useState<number>(-1);
    const [delModal, setDelModal] = useState<boolean>(false);
    const [myDocsModal, setMyDocsModal] = useState<boolean>(false);
    const [showToast, setShowToast] = useState(false);
    const [toastInfo, setToastInfo] = useState('');
    const [page, setPage] = useState(1);
    const [cleanData, setCleanData] = useState<boolean>(false);

    const onRequestClose = () => {
        setToggle(false);
    };

    const getRecommendations = async () => {
        const res = await DocumentsService.getRecommendations();
        setRecommendations(res.data.results);
    }

    useEffect(() => {
        getRecommendations()
    }, [])

    const saveRec = async () => {
        await DocumentsService.createRecommendation({ name, type, nosology, 'recommendation': text });
        setToastInfo(store.lang === 'ba' ? 'Тәҡдим өҫтәлде' : store.lang === 'ru' ? 'Рекомендация сохранена' : 'Recommendation has been saved');
        setShowToast(true);
        getRecommendations();
        if (document.getElementById('recTitle') as HTMLInputElement) {
            (document.getElementById('recTitle') as HTMLInputElement).value = ''
        };
        setText('');
        setCleanData(true);
    };

    const deleteRec = async () => {
        await DocumentsService.removeRecommendation(delId);
        setDelModal(false);
        setDelId(-1);
        getRecommendations();
    };

    useEffect(() => {
        if (!store.user.is_staff) {
            navigate('/');
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [store.user.is_staff])


    const getElemenets = () => recommendations.map((rec: any, i: number) => {
        return <Recommendation key={i} {...{ rec, i, setDelModal, setDelId }} />
    });


    return (
        <Modal isOpen={toggle} onRequestClose={onRequestClose} ariaHideApp={false} className='Modal'>
            <div className="row Modal__Head d-flex">
                <div className="col">
                    <button type='button' className='btn btn-success' onClick={() => setToggle(false)}>
                        <i className="icon close" />
                        <Trans>Close</Trans>
                    </button>
                    <button type='button' className='btn btn-success ms-3' onClick={() => setMyDocsModal(!myDocsModal)}>
                        <Trans>My files</Trans>
                    </button>
                </div>
                <div className="col text-end"><Trans>Setting up recommendations</Trans></div>
            </div>
            <form className="Modal__Body">
                <>
                    <div className='row justify-content-center pb-1'>
                        <div className='col'>
                            <ul className="nav nav-tabs justify-content-center" style={{ cursor: "pointer" }}>
                                <li className="nav-item">
                                    <span className={"nav-link" + (page === 1 ? "  active" : "")} onClick={() => setPage(1)} ><Trans>My recommendations</Trans></span>
                                </li>
                                <li className="nav-item">
                                    <span className={"nav-link" + (page === 2 ? "  active" : "")} onClick={() => setPage(2)} ><Trans>Add recommendation</Trans></span>
                                </li>
                            </ul>
                        </div>
                    </div>

                    {page === 1 ?

                        <Accordion alwaysOpen>
                            {getElemenets()}
                        </Accordion>
                        :
                        <div className="row form-group">
                            <div className="col-md-12">
                                <label htmlFor="recType" className="col-md-3 col-form-label"><Trans>Type</Trans></label>
                                <select className="form-control" onChange={(e: React.ChangeEvent<any>) => setType(e.target.value)}>
                                    <option value='1'>Родителям</option>
                                    <option value='2'>Специалистам</option>
                                </select>
                            </div>
                            <div className="col-md-12">
                                <label htmlFor="recTitle" className="col-md-3 col-form-label"><Trans>Title</Trans></label>
                                <div className="col">
                                    <input type="text" className="form-control" id="recTitle" onChange={(e) => setName(e.target.value)} />
                                </div>
                            </div>
                            <div className="col-mb-12">
                                <label htmlFor="recNosology" className="col-md-3 col-form-label"><Trans>Nosologies</Trans></label>
                                <div className="col">
                                    <RecsNosologyModal {...{ nosology, setNosology, cleanData, setCleanData }} />
                                </div>
                            </div>
                            <div className="col-md-12">
                                <label htmlFor="recText" className="col-md-3 col-form-label"><Trans>Recommendation</Trans></label>
                                <div className="col">
                                    <ReactQuill
                                        value={text}
                                        theme="snow"
                                        modules={modules}
                                        formats={formats}
                                        id="recText"
                                        onChange={setText} />
                                </div>
                            </div>
                            <div className="col mt-3">
                                <button type="button" className="btn btn-success" onClick={() => saveRec()}><Trans>Save</Trans></button>
                            </div>

                        </div>
                    }
                </>
            </form>
            <Toast className='toast p-0 border-success' bg='light' onClose={() => setShowToast(false)} show={showToast} delay={5000} autohide>
                <Toast.Header className='bg-success m-0 text-light'>
                    <strong className="me-auto"><Trans>Information</Trans></strong>
                </Toast.Header>
                <Toast.Body><strong>{toastInfo}</strong></Toast.Body>
            </Toast>
            <ModalPopover
                toggle={delModal}
                setToggle={setDelModal}
                title={store.lang === 'ba' ? 'Тәҡдимде алып ташлау' : store.lang === 'ru' ? 'Удаление рекомендации' : 'Deleting a recommendation'}
                modalContent={<Trans>Do you want to delete a recommendation?</Trans>}
                clickedButtonOne={() => deleteRec()}
                clickedButtonTwo={() => { setDelModal(false); setDelId(-1); }}
                ButtonOneValue={store.lang === 'ba' ? 'Эйе' : store.lang === 'ru' ? 'Да' : 'Yes'}
                ButtonTwoValue={store.lang === 'ba' ? 'Кире ҡайтарыу' : store.lang === 'ru' ? 'Отмена' : 'Cancel'}
            />
            <MyDocsModal toggle={myDocsModal} setToggle={setMyDocsModal} />
        </Modal>
    );
};